<template>
  <div>
    <div
      class="card"
      id="titulo"
      v-for="(item, index) in alteracoes"
      :key="index"
      @click="fecharTodos(item. toggle),item.toggle = !item.toggle"
    >
      <div class="card-header">
        <h5 class="mb-0 ml-0">
          <a class="btn btn-link">
            <i class="fas fa-cube"></i>
            <strong>NCM {{ item.ncm }}</strong>
            <span style="float:right; margin-right: 0px; line-height:0">
              {{ item.data }}
              <!-- - {{ item.hora }}-->
              <span class="icone fs-20" v-if="!item.toggle">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icone fs-20" v-if="item.toggle">
                <i class="fas fa-minus"></i>
              </span>
            </span>
            <span>{{ item.descricao }}</span>
          </a>
        </h5>
      </div>

      <transition name="exibir">
        <div class="collapse show" aria-labelledby="cabecalho alterações" v-if="item.toggle">
          <div class="card-body">
            <b>Categoria:</b>
            {{ item.categoria }}
            <br>
            <b>Aliquota atual:</b>
            {{ item.aliquota }}%
            <br>
            <b>Descrição da alteração:</b>
            {{ item.observacaoConsultor }}
            <router-link
              :to="{ name: 'Histórico', params: { ncm:item.ncm }}"
              class="btn btn-labeled btn-info mb-2"
              style="float:right; margin-top: 10px"
            >
              <span class="btn-label">
                <i class="fa fa-share"></i>
              </span>Histórico da NCM
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["alteracoes"],

  methods: {
    fecharTodos(elemento) {
      if (elemento) elemento = false;
      else {
        this.alteracoes.forEach(elemento => {
          elemento.toggle = false;
        });
      }
    }
  }
};
</script>

<style scoped>
.fs-20 {
  font-size: 15px;
  color: gray;
}
.icone {
  width: 10px;
  padding-right: 10px;
  margin-left: 10px;
  display: inline-block;
}

.exibir-enter,
.exibir-leave-to {
  min-height: 0;
  max-height: 0;
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  min-height: 1;
  max-height: 150px;
  opacity: 1;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.4s;
}
</style>